import React from "react";
import PropTypes from "prop-types";
import HoverTooltip from "../../../../../../../components/atoms/Tooltip/HoverTooltip";

const unknown = "Unknown";

const CalibratedPredictionCell = ({ database, customStyle }) => {
  if (!database?.calibratedPrediction) return null;

  const calibratedPrediction =
    database?.calibratedPrediction === unknown ? (
      <HoverTooltip
        key={`${database?.name}-${database?.calibratedPrediction}`}
        ContentRenderer={() => (
          <>
            <div className="tw-min-w-64">
              <span> No threshold received for this database.</span>
            </div>
          </>
        )}
      >
        <span>{database.calibratedPrediction}</span>
      </HoverTooltip>
    ) : (
      <>{database.calibratedPrediction}</>
    );

  return (
    <>
      <div style={customStyle} />
      <span
        data-testid="calibrated_prediction"
        style={{ color: database?.calibratedPredictionColor }}
      >
        {calibratedPrediction}
      </span>
    </>
  );
};

CalibratedPredictionCell.propTypes = {
  database: PropTypes.shape({
    calibratedPrediction: PropTypes.string,
    calibratedPredictionColor: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  customStyle: PropTypes.shape({}),
};

CalibratedPredictionCell.defaultProps = {
  customStyle: {},
};

export default CalibratedPredictionCell;
